<div class="anpp ">
  <div class="content">
    @if (entreprise) {
      <div [ngClass]="{'content-panel': creation}">
        @if (creation) {
          <div class="title-bar">
            <h4 >
              {{ title | translate}}
            </h4>
          </div>
        }

      @if (formGroup) {
        <form [formGroup]="formGroup" #form="ngForm" (submit)="submit()" novalidate>
          <div class="m-3">

          <div class="row">

            <div class="mb-3 col-lg-6">
              <label class="form-label" for="raisonsociale" translate>page.entreprises.form.label.raisonsociale</label>
              <input type="text" formControlName="raisonsociale"
                [ngClass]="{'is-invalid': form.submitted && raisonsociale.invalid}" class="form-control" />
              @if (form.submitted) {
                <ng-container>
                  @if (raisonsociale.errors?.required) {
                    <div class="form-error" translate>label.obligatoire</div>
                  }
                </ng-container>
              }
            </div>
            <div class="mb-3 col-lg-3">
              <label class="form-label" for="estadherent" translate>page.entreprises.form.label.estadherent</label>
              <div>
                <label class="form-label">
                  <input type="radio" class="me-1" formControlName="estadherent" (click)="numadherentValidatorsRequired()" (keydown.enter)="numadherentValidatorsRequired()" [value]="true" />
                  <span>Oui</span>
                </label>
                <label class="form-label">
                  <input type="radio" class="ms-5 me-1" formControlName="estadherent" (click)="numadherentValidatorsRequired()" (keydown.enter)="numadherentValidatorsRequired()" [value]="false" />
                  <span>Non</span>
                </label>
              </div>
            </div>
            <div class="mb-3 col-lg-3">
              <label class="form-label" for="numadherent" translate>page.entreprises.form.label.numadherent</label>

              <input type="text" id="numadherent" formControlName="numadherent"
                [ngClass]="{'is-invalid': form.submitted && numadherent.invalid }" class="form-control" />

              @if (form.submitted) {
                <ng-container>
                  @if (numadherent.errors?.required) {
                    <div class="form-error" translate>label.obligatoire</div>
                  }
                </ng-container>
              }
            </div>

          </div>

          <div class="mb-3">
            <label class="form-label" for="cotisationAJour" translate>page.entreprises.form.label.cotisationAJour</label>

            <div class="form-control">
              <label class="form-label">
                <input type="radio" class="me-1" formControlName="cotisationAJour" [value]="true" />
                <span>Oui</span>
              </label>
              <label class="form-label">
                <input type="radio" class="ms-5 me-1" formControlName="cotisationAJour" [value]="false" />
                <span>Non</span>
              </label>
            </div>
            @if (form.submitted) {
              <ng-container>
                @if (cotisationAJour.errors?.required) {
                  <div class="form-error" translate>label.obligatoire</div>
                }
              </ng-container>
            }
          </div>

          <div class="row">
            <div class="mb-3 col-lg-6">
              <label class="form-label" for="dateAdhesion" translate>page.entreprises.form.label.dateAdhesion</label>
              <div class="input-group">
                <input id="dateAdhesion" ngbDatepicker #dateAdhesion="ngbDatepicker" formControlName="dateAdhesion"
                  class="form-control"
                  [ngClass]="{ 'is-invalid': form.submitted && formGroup.get('dateAdhesion').invalid }" />
                <div class="input-group-append">
                  <button type="button" (click)="dateAdhesion.toggle()" class="btn btn-secondary">
                    <fa-icon icon="calendar-alt"></fa-icon>
                  </button>
                </div>
              </div>
            </div>

            <div class="mb-3 col-lg-6">
              <label class="form-label" for="dateDemission" translate>page.entreprises.form.label.dateDemission</label>
              <div class="input-group">
                <input id="dateDemission" ngbDatepicker #dateDemission="ngbDatepicker" formControlName="dateDemission"
                  class="form-control" />
                <div class="input-group-append">
                  <button type="button" (click)="dateDemission.toggle()" class="btn btn-secondary" [disabled]="isDisableDateDemission()">
                    <fa-icon icon="calendar-alt"></fa-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
          <div class="mb-3 col-lg-4">
            <label class="form-label" for="estMorale" translate>page.entreprises.form.label.estMorale</label>

            <div>
              <input type="radio" class="me-1" id="oui" formControlName="estMorale" [value]="true" />
              <label class="form-label" for="oui">Oui</label>
              <input type="radio" class="ms-5 me-1" id="non" formControlName="estMorale" [value]="false" />
              <label class="form-label" for="non">Non</label>
            </div>
          </div>
          <div class="mb-3 col-lg-8">
            <label class="form-label" for="refStructure" translate>page.entreprises.form.label.refStrusture</label>

            <select id="refStructure" formControlName="refStructure" class="form-control" [ngClass]="{'is-invalid': form.submitted && refStructure.invalid}">
              @for (refStructure of refStructures; track refStructure) {
                <option [ngValue]="refStructure">{{refStructure.libelle}}
                </option>
              }
            </select>

            @if (form.submitted) {
              <ng-container>
                @if (refStructure.errors?.required) {
                  <div class="form-error" translate>label.obligatoire</div>
                }
              </ng-container>
            }
          </div>
        </div>
          <div class="row">
            <div class="mb-3 col-lg-6">
              <label class="form-label" for="siret" translate>page.entreprises.form.label.siret</label>

              <input type="text" id="siret" formControlName="siret"
                [ngClass]="{'is-invalid': form.submitted && siret.invalid}" class="form-control" />

                @if (form.submitted) {
                  <ng-container>
                    @if (siret.errors?.pattern) {
                      <div class="form-error" translate>label.format-incorrect</div>
                    }
                  </ng-container>
                }

            </div>
            <div class="mb-3 col-lg-6">
              <label class="form-label" for="numeroTVA" translate>page.entreprises.form.label.numeroTVA</label>

              <input type="text" id="numeroTVA" formControlName="numeroTVA" class="form-control"
                [ngClass]="{'is-invalid': form.submitted && numeroTVA.invalid}" />

            </div>
          </div>
          <div class="mb-3">
            <label class="form-label" for="adresse" translate>page.entreprises.form.label.adresse</label>

            <input type="text" id="adresse" formControlName="adresse"
              [ngClass]="{'is-invalid': form.submitted && adresse.invalid}" class="form-control" />

            @if (form.submitted) {
              <ng-container>
                @if (adresse.errors?.required) {
                  <div class="form-error" translate>label.obligatoire</div>
                }
              </ng-container>
            }
          </div>
          <div class="row">
            <div class="mb-3 col-lg-2">
              <label class="form-label" for="codePostal" translate>page.entreprises.form.label.codePostal</label>
              <input (keyup)="changeValueCodePostal($event)" type="text" id="codePostal" formControlName="codePostal"
                [ngClass]="{'is-invalid': form.submitted && codePostal.invalid || (communes && communes.length === 0)}" class="form-control" />
              @if (form.submitted) {
                <ng-container>
                  @if (codePostal.errors?.required) {
                    <div class="form-error" translate>label.obligatoire</div>
                  }
                </ng-container>
              }
              @if (communes && communes.length === 0) {
                <ng-container >
                  <div class="form-error" translate>label.aucune-commune</div>
                </ng-container>
              }
            </div>
            <div class="mb-3 col-lg-6">
              <label class="form-label" for="commune" translate>page.entreprises.form.label.commune</label>

              <select formControlName="commune" class="form-control"
                [ngClass]="{'is-invalid': form.submitted && commune.invalid || (communes && communes.length === 0)}">

                @for (commune of communes; track commune) {
                  <option [ngValue]="commune">{{commune.nom}}</option>
                }
              </select>

              @if (form.submitted) {
                <ng-container>
                  @if (commune.errors?.required) {
                    <div class="form-error" translate>label.obligatoire</div>
                  }
                </ng-container>
              }

            </div>
          <div class="mb-3 col-lg-4">
            <label class="form-label" for="departement" translate>page.entreprises.form.label.departement</label>

            <div class="form-control">
              @if (departement) {
                <span>{{ departement.code }} - {{ departement.nom }}</span>
              }
            </div>
          </div>
        </div>

        <div class="row">
          <div class="mb-3 col-lg-2">
            <label class="form-label" for="telephone" translate>page.entreprises.form.label.telephone</label>

            <input type="text" id="telephone" formControlName="telephone"
              [ngClass]="{'is-invalid': form.submitted && telephone.invalid}" class="form-control" />
            @if (form.submitted) {
              <ng-container>
                @if (telephone.errors?.pattern) {
                  <div class="form-error" translate>label.format-tel-incorrect</div>
                }
              </ng-container>
            }
          </div>
          <div class="mb-3 col-lg-10">
            <label class="form-label" for="mail" translate>page.entreprises.form.label.mail</label>

            <input type="text" id="mail" formControlName="mail"
              [ngClass]="{'is-invalid': form.submitted && mail.invalid}" class="form-control" />
            @if (form.submitted) {
              <ng-container>
                @if (mail.errors?.pattern) {
                  <div class="form-error" translate>label.format-incorrect</div>
                }
              </ng-container>
            }
          </div>
        </div>
        <div class="row">
          <div class="mb-3 col-lg-6">
            <label class="form-label" for="refSousType" translate>page.entreprises.form.label.refSousType</label>

            <select id="refSousType" formControlName="refSousType" (change)="numeroReconnaissanceValidatorsRequired();entrepriseLieeValidatorsRequired()"  class="form-control" [ngClass]="{'is-invalid': form.submitted && refSousType.invalid}" >
              @for (refsousType of refSousTypes; track refsousType) {
                <option [ngValue]="refsousType">{{refsousType.libelle}}</option>
              }
            </select>

            @if (form.submitted) {
              <ng-container>
                @if (refSousType.errors?.required) {
                  <div class="form-error" translate>label.obligatoire</div>
                }
              </ng-container>
            }
          </div>
          <div class="mb-3 col-lg-6">
            <label class="form-label" for="numeroReconnaissance" translate>page.entreprises.form.label.numeroReconnaissance</label>

            <input type="text" id="numeroReconnaissance" formControlName="numeroReconnaissance"
              [ngClass]="{'is-invalid': form.submitted && numeroReconnaissance.invalid}" class="form-control" />

            @if (form.submitted) {
              <ng-container>
                @if (numeroReconnaissance.errors?.required) {
                  <div class="form-error" translate>label.obligatoire</div>
                }
              </ng-container>
            }
          </div>
        </div>
          <div class="mb-3">
            <label class="form-label" for="entrepriseLiee" translate>page.entreprises.form.label.entreprise</label>

            <select id="entrepriseLiee" formControlName="entrepriseLiee" class="form-control" (change)="entrepriseLieeValidatorsRequired()"
            [ngClass]="{'is-invalid': form.submitted && EntrepriseLieeRequise }">
              <option [ngValue]="undefined" ></option>
              @for (entreprise of entreprises; track entreprise) {
                <option [ngValue]="entreprise">{{entreprise.raisonSociale}}
                </option>
              }
            </select>

            @if (form.submitted) {
              <ng-container>
                @if (EntrepriseLieeRequise) {
                  <div class="form-error" translate>label.obligatoire</div>
                }
              </ng-container>
            }
          </div>
          <div class="row">
          <div class="mb-3 col-lg-4">
            <label class="form-label" for="cultureBio" translate>page.entreprises.form.label.cultureBio</label>

            <div class="form-control">
              <label class="form-label">
                <input type="radio" class="me-1" formControlName="cultureBio" [value]="true" />
                <span>Oui</span>
              </label>
              <label class="form-label">
                <input type="radio" class="ms-5 me-1" formControlName="cultureBio" [value]="false" />
                <span>Non</span>
              </label>
            </div>

            @if (form.submitted) {
              <ng-container>
                @if (cultureBio.errors?.required) {
                  <div class="form-error" translate>label.obligatoire</div>
                }
              </ng-container>
            }
          </div>
          <div class="mb-3 col-lg-4">
            <label class="form-label" for="ecoresponsable" translate>page.entreprises.form.label.ecoresponsable</label>

            <div class="form-control">
              <label class="form-label">
                <input type="radio" class="me-1" formControlName="ecoresponsable" [value]="true" />
                <span>Oui</span>
              </label>
              <label class="form-label">
                <input type="radio" class="ms-5 me-1" formControlName="ecoresponsable"  [value]="false" />
                <span>Non</span>
              </label>
            </div>


          </div>
          <div class="mb-3 col-lg-4">
            <label class="form-label" for="codeComptable" translate>page.entreprises.form.label.codeComptable</label>
            <input type="text"  id="codeComptable" (change)="changeValueCodeComptable($event)"
              formControlName="codeComptable" [ngClass]="{'is-invalid': codeComptableExiste}" class="form-control" />
            @if (codeComptableExiste) {
              <ng-container>
                <div class="form-error" translate>label.code-comptable-existe</div>
              </ng-container>
            }
          </div>
        </div>
          <div class="mb-3">
            <label class="form-label" for="commentaire" translate>page.entreprises.form.label.commentaire</label>

            <textarea rows="2" id="commentaire" formControlName="commentaire"
              [ngClass]="{'is-invalid': form.submitted && commentaire.invalid}" class="form-control" >
            </textarea>

          </div>

        </div>

        <div class="actions-bar justify-content-between">
          <button class="btn  btn-secondary btnprimary " (click)="onClose()" translate>label.retour</button>

          <button type="submit" class="btn btn-secondary btnprimary" translate>{{!creation
            ? 'label.suivant': 'label.valider'}}</button>
        </div>
      </form>
      }
      </div>
    }
  </div>
</div>
